import styled from '@emotion/styled'
import theme from '../../../styles/theme'

export const LineDivider = styled.div`
  height: 1px;
  background-color: ${theme.colors.background};
  margin: 0.5rem 0;
`
